import { Box, Stack, Typography } from '@mui/material';
import '../../App.css';
import SeatRedImage from '../../assets/images/car_seat/seat_red.png';
import SeatBrownImage from '../../assets/images/car_seat/seat_brown.png';
import SeatGreenImage from '../../assets/images/car_seat/seat_green.png';

const CarSeatAvailabilityTab = (props) => {
    const { packet } = props;

    let vvvf1Color = '';
    let vvvf2Color = '';

    if (packet.board2 !== null) {
        const vvvf1VarLoadSignalDec = packet.board2.vvvf1.varLoadSignalDec;
        const vvvf2VarLoadSignalDec = packet.board2.vvvf2.varLoadSignalDec;

        /*
        red > b0 (176)
        amber > 8B (139)
        green <= 8B
        */

        if (vvvf1VarLoadSignalDec > 176) {
            vvvf1Color = 'red';
        } else if (vvvf1VarLoadSignalDec > 139) {
            vvvf1Color = 'brown';
        } else {
            vvvf1Color = 'green';
        }

        if (vvvf2VarLoadSignalDec > 176) {
            vvvf1Color = 'red';
        } else if (vvvf2VarLoadSignalDec > 139) {
            vvvf2Color = 'brown';
        } else {
            vvvf2Color = 'green';
        }
    }

    return (
        <>
            {(packet.board2 !== null) && (
                <Box sx={{ flexGrow: 1, padding: '8px' }}>
                    <Stack direction="column" sx={{ width: '100%', alignItems: 'center', alignContent: 'center' }}>
                        <Typography sx={{ textAlign: 'center', fontSize: 28 }}>
                            Seat Availability
                        </Typography>
                        <Stack direction="row">
                            <Stack direction="column">
                                <Typography sx={{ textAlign: 'center', fontSize: 28 }}>
                                        1
                                </Typography>

                                {(vvvf1Color === 'red') && (
                                    <img src={SeatRedImage} alt="Red" style={{ width: '200px' }} />
                                )}
                                {(vvvf1Color === 'brown') && (
                                    <img src={SeatBrownImage} alt="Amber" style={{ width: '200px' }} />
                                )}
                                {(vvvf1Color === 'green') && (
                                    <img src={SeatGreenImage} alt="Green" style={{ width: '200px' }} />
                                )}
                            </Stack>
                            <Stack direction="column" sx={{ marginLeft: '8px' }} >
                                <Typography sx={{ textAlign: 'center', fontSize: 28 }}>
                                    2
                                </Typography>

                                {(vvvf2Color === 'red') && (
                                    <img src={SeatRedImage} alt="Red" style={{ width: '200px' }} />
                                )}
                                {(vvvf2Color === 'brown') && (
                                    <img src={SeatBrownImage} alt="Amber" style={{ width: '200px' }} />
                                )}
                                {(vvvf2Color === 'green') && (
                                    <img src={SeatGreenImage} alt="Green" style={{ width: '200px' }} />
                                )}
                            </Stack>
                        </Stack>
                    </Stack>
                </Box>
            )}
        </>
    );
};

export default CarSeatAvailabilityTab;